import { Component, inject, model } from '@angular/core';
import { DataGridStore } from '../../store/data-grid.store';

@Component({
  host: {
    ngSkipHydration: 'true',
  },
  selector: 'lepi-checkbox-column',
  standalone: true,
  template: `
    <div class="flex justify-center">
      <input
        [checked]="value()"
        (change)="valueChange($any($event.target).checked)"
        type="checkbox"
        class="rounded checkbox-primary border-base-content/20 checkbox" />
    </div>
  `,
})
export class CheckboxColumn {
  readonly store = inject(DataGridStore);

  value = model<boolean>(false);
  selecteds = model<any[]>([]);

  /**
   * @description 전체 선택/해제
   * @param ev
   */
  valueChange(ev: boolean) {
    const rowData = this.store.rowData() || [];

    if (ev) {
      this.selecteds.set(rowData);
    } else {
      this.selecteds.set([]);
    }
  }
}
